// Termos e Condições dos promocodes + o deep-link do modal.
//
// O texto vinha hardcoded dentro de `components/promocode/Page.vue`, que era o
// único lugar que o mostrava. Com o modal (`components/promocode/Modal.vue`)
// passaram a ser dois leitores, e copy jurídica duplicada é copy que sai de
// sincronia — então ela mora aqui, uma vez só.
//
// Estrutura em blocos (título + parágrafos) e não uma lista plana de linhas: o
// modal desenha o título com peso próprio, como o painel de termos da roletinha.
// A versão plana de antes só existia porque o `BaseModalMissionModal` renderizava
// tudo com o mesmo estilo.

export interface PromocodeTermsSection {
  title: string;
  paragraphs: string[];
}

export const PROMOCODE_TERMS_TITLE =
  'Termos e Condições – Promocodes operadora';

export const PROMOCODE_TERMS_INTRO =
  'Os promocodes são benefícios oferecidos pela operadora de forma pontual e seguem as regras abaixo. Ao utilizá-los, o jogador concorda com estes termos.';

export const PROMOCODE_TERMS: PromocodeTermsSection[] = [
  {
    title: '1. Uso e Elegibilidade',
    paragraphs: [
      'Cada promocode tem um número máximo de usos, definido internamente pela operadora, e pode ser resgatado apenas uma vez por jogador.',
      'Algumas campanhas podem ser restritas a novos jogadores ou a contas ativas, conforme informado na comunicação oficial.',
      'A participação é destinada exclusivamente a maiores de 18 anos.',
      'Ao aceitar os Termos do site, o jogador passa a participar automaticamente das promoções, bônus e comunicações da operadora, podendo receber ofertas e novidades por diferentes canais (e-mail, SMS, notificações, entre outros). O jogador pode cancelar o recebimento dessas comunicações a qualquer momento, bastando acessar a aba "Dados da Conta" e ajustar suas preferências.',
    ],
  },
  {
    title: '2. Benefícios',
    paragraphs: [
      'Podem incluir saldo real, giros grátis, giros em minigames ou outros prêmios, conforme cada campanha.',
      'Quando houver valor mínimo de depósito ou de aposta, isso será informado no momento da divulgação.',
      'Não há exigência de rollover, salvo se comunicado de forma expressa na divulgação do código.',
      'Quando o prêmio for de natureza variável (por exemplo, baús ou prêmios surpresa), as possibilidades de prêmio serão informadas na divulgação.',
    ],
  },
  {
    title: '3. Validade',
    paragraphs: [
      'Cada promocode pode ter prazo de validade e/ou limite de estoque próprios, informados no momento da divulgação.',
      'Após expirado o prazo ou esgotado o estoque, o código deixa de ser resgatável.',
    ],
  },
  {
    title: '4. Segurança e Controle',
    paragraphs: [
      'É proibido o uso de múltiplas contas ou qualquer tentativa de fraude.',
      'Em caso de uso indevido, a operadora poderá cancelar o benefício e, havendo indícios concretos de fraude, suspender a conta para análise. Antes de decisão definitiva que implique bloqueio da conta ou perda de benefício, o jogador será notificado e poderá apresentar esclarecimentos em prazo razoável, salvo obrigação legal em sentido diverso.',
    ],
  },
  {
    title: '5. Comunicação',
    paragraphs: [
      'Promocodes são divulgados apenas por canais oficiais (lives, Telegram, Instagram ou outros canais da operadora) e por parceiros oficiais.',
      'As comunicações de promocodes, inclusive as feitas por parceiros e influenciadores, observam as regras de publicidade responsável, o aviso de idade (+18) e as advertências de jogo responsável.',
    ],
  },
  {
    title: '6. Condicionalidade',
    paragraphs: [
      'O recebimento de promocodes depende do cumprimento das regras de elegibilidade.',
      'A operadora não é obrigada a disponibilizar promocodes para todos os usuários.',
    ],
  },
  {
    title: '7. Jogo Responsável',
    paragraphs: [
      'Esta promoção é destinada a maiores de 18 anos. Apostar pode causar dependência e levar à perda de dinheiro. Aposta não é investimento. Jogue com responsabilidade. O jogador pode definir limites e solicitar autoexclusão nos canais oficiais.',
    ],
  },
];

// Deep-link do modal: `?open=promocode`. Mesma convenção do Check-in Diário
// (`utils/apostatudo/daily-checkin-deep-link`): a lista de grafias mora fora do
// layout porque é contrato com o CMS, onde os links são preenchidos à mão.
// Canônico p/ divulgar: `promocode`.
export const PROMOCODE_QUERY_VALUES = ['promocode', 'promo-code', 'codigo'];

// Valor do `?open=` da rota atual (que no Vue Router pode vir como array quando
// o parâmetro aparece repetido).
export function isPromocodeOpenParam(value: unknown): boolean {
  const first = Array.isArray(value) ? value[0] : value;

  return typeof first === 'string' && PROMOCODE_QUERY_VALUES.includes(first);
}
